import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { GoodsClass } from 'src/types/api/trademarkRightsApiTypes';
import { Table, Title, Content, TopItem } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: GoodsClass[];
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 商標權狀態異動資料 區塊。
 */
const InfoGoods: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;
  return (
    <DropdownInfo
      title={`商品類別與商品(服務)名稱`}
      isShow={isShow}
      setIsShow={setIsShow}
      color={angleColor}
    >
      {data.length !== 0 && (
        <>
          {data.map((item, index) => {
            index += 1;
            return (
              <Table color={tableColor} key={index}>
                <TopItem>
                  <Title>商品或服務類別資訊</Title>
                  <Content>
                    {item.goodsClassCode && item.goodsClassCode !== '　'
                      ? item.goodsClassCode
                      : noContent}
                  </Content>
                </TopItem>
                <TopItem>
                  <Title>商品名稱</Title>
                  <Content>{item.goodsName || noContent}</Content>
                </TopItem>
                <TopItem>
                  <Title>類似組群</Title>
                  <Content>{item.goodsGroup || noContent}</Content>
                </TopItem>
              </Table>
            );
          })}
        </>
      )}
    </DropdownInfo>
  );
};

export default InfoGoods;
